import { render, staticRenderFns } from "./ProjectDetailsFinances.vue?vue&type=template&id=2183ded7&scoped=true&"
import script from "./ProjectDetailsFinances.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsFinances.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsFinances.vue?vue&type=style&index=0&id=2183ded7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183ded7",
  null
  
)

export default component.exports